<template>
    <mu-col span="12 menu-mobile">
        <mu-row class="d-flex justify-content-between h-100">
            <mu-col span="1" sm="1" md="1" class="d-flex justify-content-center align-items-center h-100">
                <mu-button icon @click="open = !open" class=" d-flex justify-content-center align-items-center">
                    <mu-icon value="menu" color="primary"></mu-icon>
                </mu-button>
            </mu-col>
            <mu-col span="5" sm="3" md="2" class="img-logo-brand-mobile">
                <router-link to="/" custom v-slot="{ navigate }">
                    <span @click="navigate" @keypress.enter="navigate" role="link">
                        <picture @click="tab_active = 0" class="d-flex justify-content-end">
                            <source srcset="/images/logos/nayaritplus.webp" type="image/webp" :alt="$t('alt.logo')" class="size-logo"/>
                            <img src="/images/logos/nayaritplus.png" :alt="$t('alt.logo')" class="size-logo"/>
                        </picture>
                    </span>
                </router-link>
            </mu-col>
            <mu-drawer :open.sync="open" :docked="docked" :right="position === 'right'" style="background-color: #000;">
                <mu-col span="12">
                    <div class="d-flex justify-content-end pt-3">
                        <mu-icon value="clear" color="#fafafa" @click="open = false"></mu-icon>
                    </div>
                </mu-col>
                <mu-list>
                    <div v-for="item, index in menu" :key="`col_${index}`" class="items-mobile pl-0">
                        <mu-list-item :href="item.link" button @click="open = false" class="pl-0" v-if="item.name != 'schedules'" :target="isExternalLink(item.link) ? '_blank' : '_self'">
                            <mu-list-item-title class="pl-0">
                                <span v-if="item.html != null" v-html="item.html" class="mr-1"></span>
                                <label class="buttonTextMobile">{{ $t(`button_action.mobile.${item.name}`)}}</label>
                            </mu-list-item-title>
                        </mu-list-item>
                        <mu-list-item :href="item.link" button @click="open = false" class="pl-0" v-else>
                            <mu-list-item-title class="pl-0">
                                <span v-if="item.html != null" v-html="item.html[0]" class="px-0 mx-0"></span>
                                <span v-if="item.html != null" v-html="item.html[1]" class="px-0 mx-0"></span>
                                <label class="buttonTextMobileCombined">{{ $t(`button_action.mobile.${item.name}`)}}</label>
                            </mu-list-item-title>
                        </mu-list-item>
                        <mu-divider style="background-color: rgba(255, 255, 255, .5) !important"></mu-divider>
                    </div>
                </mu-list>
            </mu-drawer>
        </mu-row>
    </mu-col>
</template>
<script>
export default {
    data() {
        return {
            open: false,
            docked: false,
            position: 'left',
            menu: [
                {
                    name: "cellphones",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/cellphones_white.svg'/>",
                    // link: "/contact-center"
                    link: "/"
                },
                // {
                //     name: "wifi",
                //     html: "<img class='buttonLogo' src='/images/navbar/new_icons/wifi_white.svg'/>",
                //     link: "/internet"
                // },
                {
                    name: "schedules",
                    html: ["<img class='buttonLogoMobileCombined' src='/images/navbar/new_icons/schedules_white.svg'/>", "<img class='buttonLogoMobileCombined' src='/images/navbar/new_icons/rates_white.svg'/>"],
                    link: "/horarios-y-tarifas"
                },
                {
                    name: "buses",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/bus_white.svg'/>",
                    link: "/autobuses"
                },
                {
                    name: "terminal_locations",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/locations_white.svg'/>",
                    link: "/"
                    // link: "/ubicaciones"
                },
                {
                    name: "services",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/service_white.svg'/>",
                    link: "/"
                    // link: "/servicios"
                },
                {
                    name: "travel_tips",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/tips_white.svg'/>",
                    link: "/"
                    // link: "/tips-viaje"
                },
                
                {
                    name: "traveller",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/traveller_white.svg'/>",
                    link: "https://viajero.vallartaplus.mx/"
                },
                {
                    name: "shipper",
                    html: "<img class='buttonLogo' src='/images/navbar/new_icons/shipper_white.svg'/>",
                    link: "/envios"
                },
                {
                    name: "trip_airport",
                    html: "<img class='buttonLogo' src='/images/logos/tepicplus_1.png'/>",
                    link: "https://www.tepicplus.com/"
                }
            ]
        }
    },
    methods: {
        isExternalLink(link) {
            return link.startsWith('http') || link.startsWith('//');
        }
    }
}
</script>
<style lang="scss" scoped>
.items-mobile {
    .buttonLogoMobile {
        width: 20px !important;
        height: 20px !important;
    }
	.buttonLogoMobileCombined {
        width: 20px !important;
        height: 20px !important;
    }
    .buttonTextMobile {
        font-size: 0.75em;
        margin: 0px;
        color: white;
        text-decoration: none;
        line-height: 15px;
    }
	.buttonTextMobileCombined {
        font-size: 0.75em;
        margin: 0px;
        color: white;
        text-decoration: none;
        line-height: 15px;
    }
}
.menu-mobile{
    height: 95px;
    color: #fff;
}
.img-logo-brand-mobile
{
    .size-logo {
        width: 90%;
        height: 95px;
    }
}
</style>